import type ScreeningPolicyRepository from "@/core/administration/repositories/ScreeningPolicyRepository";
import type {
  ScreeningPolicy,
  UpdateScreeningPolicyInput,
} from "@/core/administration/entities/ScreeningPolicy";
import { RepositoryResult } from "@/core/shared/types/RepositoryResult";
import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import screeningPolicyEndpoints from "../../api/screeningPolicyEndpoints/screeningPolicyEndpoints";

type ScreeningPolicyDto = {
  pepBlocksCreation: boolean;
  highBlocksCreation: boolean;
  vneuroneMode: ScreeningPolicy["vneuroneMode"];
  screeningProvider: ScreeningPolicy["screeningProvider"];
  updatedBy: string | null;
  updatedAt: string | null;
};

function mapDto(dto: ScreeningPolicyDto): ScreeningPolicy {
  return {
    pepBlocksCreation: dto.pepBlocksCreation,
    highBlocksCreation: dto.highBlocksCreation,
    vneuroneMode: dto.vneuroneMode,
    screeningProvider: dto.screeningProvider,
    updatedBy: dto.updatedBy,
    updatedAt: dto.updatedAt,
  };
}

export default class ScreeningPolicyRepositoryBackend
  implements ScreeningPolicyRepository
{
  constructor(private readonly httpClient: HttpClient) {}

  getPolicy(): Promise<RepositoryResult<ScreeningPolicy>> {
    return executeRequest(
      () =>
        this.httpClient.get<ApiResponse<ScreeningPolicyDto>>({
          url: screeningPolicyEndpoints.policy(),
          withAuth: true,
        }),
      mapDto,
    );
  }

  updatePolicy(
    input: UpdateScreeningPolicyInput,
  ): Promise<RepositoryResult<ScreeningPolicy>> {
    return executeRequest(
      () =>
        this.httpClient.put<
          ApiResponse<ScreeningPolicyDto>,
          UpdateScreeningPolicyInput
        >({
          url: screeningPolicyEndpoints.policy(),
          body: input,
          withAuth: true,
        }),
      mapDto,
    );
  }
}
